import { useEffect } from 'react'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'

import Account from './components/Account/Account'
import Actions from './components/Actions/Actions'
import Admin from './components/Admin/Admin'
import Analytics from './components/Analytics/Analytics'
import Configuration from './components/Configuration/Configuration'
import Conversations from './components/Conversations/Conversations'
import Faq from './components/Faq/Faq'
import Layout from './components/Layout/Layout'
import Login from './components/Login/Login'
import Lookup from './components/Lookup/Lookup'
import Messages from './components/Messages/Messages'
import NLUPage from './components/NLUData/NLUData'
import NLUStats from './components/NLUData/NLUStats/NLUStats'
import NotFound from './components/NotFound/NotFound'
import RequireAuth from './components/RequireAuth/RequireAuth'
import Responses from './components/Responses/Responses'
import Rules from './components/Rules/Rules'
import SlotsForms from './components/SlotsForms/SlotsForms'
import Users from './components/Users/Users'
import { Mode } from './types/mode'
import { IRoleEnum } from './types/router'
import { isMode } from './utils/isMode'

import 'react-toastify/dist/ReactToastify.css'

function App() {
    const location = useLocation()
    const navigate = useNavigate()

    useEffect(() => {
        if (location.pathname === '/') {
            navigate('/training-data/data')
        }
    }, [location.pathname, navigate])

    return (
        <QueryParamProvider adapter={ReactRouter6Adapter}>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                    element={
                        <RequireAuth roles={[IRoleEnum.ADMIN, IRoleEnum.USER]}>
                            <Layout />
                        </RequireAuth>
                    }
                >
                    {isMode(Mode.ENHANCED) ? (
                        <>
                            <Route path="/rules" element={<Rules />} />
                            <Route path="/rules/:ruleId" element={<Rules />} />
                            <Route
                                path="/slots-forms"
                                element={<SlotsForms />}
                            />
                            <Route path="/actions" element={<Actions />} />
                            <Route path="/config" element={<Configuration />} />
                            <Route path="/messages" element={<Messages />} />
                            <Route
                                path="/messages/:messageId"
                                element={<Messages />}
                            />
                        </>
                    ) : null}

                    <Route path="/conversations" element={<Conversations />} />
                    <Route
                        path="/conversations/:conversationId"
                        element={<Conversations />}
                    />

                    <Route path="/faq" element={<Faq />} />
                    <Route path="/training-data">
                        <Route
                            path="/training-data/data"
                            element={<NLUPage />}
                        />
                        <Route
                            path="/training-data/data/:tab"
                            element={<NLUPage />}
                        />
                        {isMode(Mode.ENHANCED) ? (
                            <>
                                <Route
                                    path="/training-data/lookup"
                                    element={<Lookup />}
                                />
                                <Route
                                    path="/training-data/stats"
                                    element={<NLUStats />}
                                />
                            </>
                        ) : null}
                    </Route>
                    <Route path="/responses" element={<Responses />} />
                    <Route path="/analytics" element={<Analytics />} />
                    <Route path="/*" element={<NotFound />} />
                    <Route path="/account" element={<Account />} />
                </Route>
                <Route
                    element={
                        <RequireAuth roles={[IRoleEnum.ADMIN]}>
                            <Layout />
                        </RequireAuth>
                    }
                >
                    <Route path="/users" element={<Users />} />
                    <Route path="/webhooks" element={<Admin />} />
                </Route>
            </Routes>
        </QueryParamProvider>
    )
}

export default App
